import api from "../api/axiosConfig";

const userService = {
  getUsers: () => api.get("/users"),
  getProductionWorkers: () => api.get("/production-workers"),
  createUser: (data) => api.post("/users", data),
  updateUser: (id, data) => api.patch(`/users/${id}`, data),
  deleteUser: (id) => api.delete(`/users/${id}`),
  changePassword: (id, password) => api.post(`/users/${id}/password`, { password }),
};

export default userService;